import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'

import { getDriveFiles } from '../../handlers/googleApis'
import './Modals.css'

export default function CsddSource({ modalOpen, reportState, gdriveReportsState, inputs }) {
  const {isModalOpen, setIsModalOpen} = modalOpen
  const {reports, setReports} = reportState
  const {gdriveReports, setGdriveReports} = gdriveReportsState
  const [receivedInventoryOptions, setReceivedInventoryOptions] = useState([])
  const [fbaReturnsOptions, setFbaReturnsOptions] = useState([])
  const [salesHistoryOptions, setSalesHistoryOptions] = useState([])

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const handleFileChange = (e) => {
    const { id, files } = e.target
    setReports(prevState => ({
      ...prevState,
      [id]: files[0]
    }))
  }

  const getReceivedInventoryFiles = async(marketplace) => {
    const folderId = marketplace === 'A2EUQ1WTGCTBG2' ? 'RECEIVED_INV_GDRIVE_FOLDER_ID_CA' : 'RECEIVED_INV_GDRIVE_FOLDER_ID_US'
    const response = await getDriveFiles({folderId})
    setReceivedInventoryOptions(response?.files || [])
    setGdriveReports(prevState => ({
      ...prevState,
      received_inv: response?.files?.[0] || null
    }))
  }

  const getFbaReturnFiles = async(marketplace) => {
    const folderId = marketplace === 'A2EUQ1WTGCTBG2' ? 'FBA_RETURNS_GDRIVE_FOLDER_ID_CA' : 'FBA_RETURNS_GDRIVE_FOLDER_ID_US'
    const response = await getDriveFiles({folderId})
    setFbaReturnsOptions(response?.files || [])
    setGdriveReports(prevState => ({
      ...prevState,
      fba_return: response?.files?.[0] || null
    }))
  }

  const getSalesHistoryFiles = async(marketplace) => {
    const folderId = marketplace === 'A2EUQ1WTGCTBG2' ? 'SALES_HISTORY_GDRIVE_FOLDER_ID_CA' : 'SALES_HISTORY_GDRIVE_FOLDER_ID_US'
    const response = await getDriveFiles({folderId})
    setSalesHistoryOptions(response?.files || [])
    setGdriveReports(prevState => ({
      ...prevState,
      sales_history: response?.files?.[0] || null
    }))
  }

  const handleSelectChange = (e) => {
    const { id, value } = e.target
    const selectedFile = receivedInventoryOptions.find(file => file.id === value) 
      || fbaReturnsOptions.find(file => file.id === value)
      || salesHistoryOptions.find(file => file.id === value)

    setGdriveReports(prevState => ({
      ...prevState,
      [id]: selectedFile
    }))
  }

  useEffect(()=>{
    getReceivedInventoryFiles(inputs.marketplace)
    getFbaReturnFiles(inputs.marketplace)
    getSalesHistoryFiles(inputs.marketplace)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[inputs.marketplace])

  return (
    <Modal
      className='x_saveModal x_ddParserModal x_cssddModal'
      isOpen={isModalOpen}
      onAfterOpen={() => {}}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <h4>Amazon Reports Uploads:</h4>
      <i className='fa-solid fa-window-minimize x-minimize' onClick={closeModal}></i>
      <div className='x_csddModal_input_container1'>
        <div className='x_csddModal_input_container2a'>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='all_listings' className='x_label form-label'>
              All Listings Report: 
              <span className='x_active_file'>{reports?.all_listings?.name || '-'}</span>
            </label>
            <input id='all_listings' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='active_listings' className='x_label form-label'>
              Active Listings Report:
              <span className='x_active_file'>{reports?.active_listings?.name || '-'}</span>
            </label>
            <input id='active_listings' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='suppressed_listings' className='x_label form-label'>
              Suppressed Listings Report:
              <span className='x_active_file'>{reports?.suppressed_listings?.name || '-'}</span>
            </label>
            <input id='suppressed_listings' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='amz_fulfilled' className='x_label form-label'>
              Amazon Fulfilled Inventory Report:
              <span className='x_active_file'>{reports?.amz_fulfilled?.name || '-'}</span>
            </label>
            <input id='amz_fulfilled' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='manage_inv' className='x_label form-label'>
              Manage Inventory Report:
              <span className='x_active_file'>{reports?.manage_inv?.name || '-'}</span>
            </label>
            <input id='manage_inv' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='res_inv' className='x_label form-label'>
              Reserved Inventory Report:
              <span className='x_active_file'>{reports?.res_inv?.name || '-'}</span>
            </label>
            <input id='res_inv' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='inv_health' className='x_label form-label'>
              Inventory Health Report:
              <span className='x_active_file'>{reports?.inv_health?.name || '-'}</span>
            </label>
            <input id='inv_health' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='received_inv' className='x_label form-label'>
              Received Inventory Databank:
              <span className='x_active_file'>{gdriveReports?.received_inv?.name || '-'}</span>
            </label>
            <select id='received_inv' className='x_form-select x_csdd-form-select form-select'onChange={handleSelectChange}>
              <option value='' disabled className='x_option-placeholder'>- Select a file -</option>
              {receivedInventoryOptions.map(file => (
                <option key={file.id} value={file.id}>{file.name}</option>
              ))}
            </select>
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='fba_return' className='x_label form-label'>
              FBA Returns Databank:
              <span className='x_active_file'>{gdriveReports?.fba_return?.name || '-'}</span>
            </label>
            <select id='fba_return' className='x_form-select x_csdd-form-select form-select'onChange={handleSelectChange}>
              <option value='' disabled className='x_option-placeholder'>- Select a file -</option>
              {fbaReturnsOptions.map(file => (
                <option key={file.id} value={file.id}>{file.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className='x_csddModal_input_container2b'>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='pricing_health' className='x_label form-label'>
              Pricing Health:
              <span className='x_active_file'>{reports?.pricing_health?.name || '-'}</span>
            </label>
            <input id='pricing_health' type='file' accept='.xlsb, .xlsx'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='30d_business' className='x_label form-label'>
              30D Business Report:
              <span className='x_active_file'>{reports?.['30d_business']?.name || '-'}</span>
            </label>
            <input id='30d_business' type='file' accept='.csv'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='7d_business' className='x_label form-label'>
              7D Business Report:
              <span className='x_active_file'>{reports?.['7d_business']?.name || '-'}</span>
            </label>
            <input id='7d_business' type='file' accept='.csv'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='sales_history' className='x_label form-label'>
              Sales History Databank:
              <span className='x_active_file'>{gdriveReports?.sales_history?.name || '-'}</span>
            </label>
            <select id='sales_history' className='x_form-select x_csdd-form-select form-select'onChange={handleSelectChange}>
              <option value='' disabled className='x_option-placeholder'>- Select a file -</option>
              {salesHistoryOptions.map(file => (
                <option key={file.id} value={file.id}>{file.name}</option>
              ))}
            </select>
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='fee_preview' className='x_label form-label'>
              Fee Preview Report:
              <span className='x_active_file'>{reports?.fee_preview?.name || '-'}</span>
            </label>
            <input id='fee_preview' type='file' accept='.xlsx, .txt'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
          <div className='x_fileInput-container x_fileInput-container-modal'>
            <label htmlFor='sc_listing_issues' className='x_label form-label'>
              Seller Central Listing Issues:
              <span className='x_active_file'>{reports?.sc_listing_issues?.name || '-'}</span>
            </label>
            <input id='sc_listing_issues' type='file' accept='.xlsb, .xlsx'
              className='x_fileInput x_fileInput2 form-control' 
              onChange={handleFileChange} 
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}